<template>
  <div class="box">
    <div class="box-header">
      <div class="col-6 col-md-6 col-sm-8 col-xs-8">
        <div class="box-tools">
          <div class="input-group input-group-sm div-pesquisa">
            <input v-model="filterText" @keyup.enter="doFilter" type="text" class="form-control pull-right" placeholder="Pesquisar...">
            <div class="input-group-btn">
              <button type="button" class="btn btn-info" @click="doFilter"><i class="fa fa-search"></i></button>
            </div>
          </div>
        </div>
      </div>

      <div class="col-6 col-md-6 col-sm-4 col-xs-4 div-btn-novo">
        <button id="newButton" class="btn btn-sm btn-primary btn-novo" @click="novo()" style="width: 33px" data-tooltip="Novo"><i class="fa fa-plus" aria-hidden="true"></i></button>
        <export-excel
          :fields = "listaExcelFields"
          :fetch = "gerarExcel"
          type = "xls"
          worksheet = "Ponto de Apoio"
          name = "zanzar-distribuicao-lote.xls"
          class="btn btn-sm btn-primary btn-novo" style="width: 33px"
          data-tooltip="Exportar Excel"
        ><i class="fa fa-file-excel"></i></export-excel>
      </div>
    </div>

    <vuetable ref="vuetable"
      :api-url="urlApi"
      :http-options="httpOptions"
      :fields="fields"
      :sort-order="sortOrder"
      :css="css.table"
      pagination-path=""
      :per-page="25"
      :append-params="moreParams"
      @vuetable:pagination-data="onPaginationData"
      @vuetable:loading="onLoading"        
      @vuetable:loaded="onLoaded"
    >
      <template slot="status_desc" slot-scope="props">
        <span class="label" v-bind:class="{
            'label-info': props.rowData.idc_status === 1,
            'label-warning': props.rowData.idc_status === 2,
            'label-success': props.rowData.idc_status === 3,
            'label-default': props.rowData.idc_status === 9
          }">{{ props.rowData.status_desc }}</span>
      </template>
      <template slot="actions" slot-scope="props">
        <div class="table-button-container" style="text-align: center">
          <div class="btn-group">
            <a @click="view(props.rowData)" class="btn btn-sm btn-success legitRipple" data-tooltip="Abrir" data-delay="500" data-hasqtip="0" aria-describedby="qtip-0"><span class="glyphicon glyphicon-eye-open"></span></a>
          </div>
        </div>
      </template>
    </vuetable>
    <vuetable-pagination ref="pagination" :css="css.pagination" @vuetable-pagination:change-page="onChangePage"/>
  </div>
</template>

<script>
import Vue from 'vue'
import { Vuetable, VuetablePagination, VuetablePaginationDropdown, VuetablePaginationBootstrap } from 'vuetable-2'

import ActionsLogin from '../../actions/LoginActions'
import DistribuicaoLoteActions from '../../actions/DistribuicaoLoteActions'
import moment from 'moment'

export default {
  name: 'Listar',
  props: ['titulo', 'status'],
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationDropdown,
    VuetablePaginationBootstrap
  },
  data () {
    return {
      titleModal: '',
      isModalPerfil: false,
      isModalImagemPerfil: false,
      imagemPerfil: '',
      historico: null,
      cdApuracao: null,
      errorMessageModal: '',
      errors: {},
      listaExcelFields: {
        'Codigo': 'cd_apuracao',
        'Cod Motorista': 'cd_motorista',
        'Cod Ponto Apoio': 'cd_ponto_apoio',
        'Data': 'dt_agendada',
        'Observação': 'observacao',
        'Cod Status': 'idc_status',
        'Status': 'status_desc',
        'Criado em': 'createdAt',
        'Alterado em': 'updatedAt',
        'Motorista': 'motorista.nome',
        'CPF': 'motorista.cpf'
      },
      filterText: '',
      urlApi: process.env.URL_API_BASE + '/distribuicao-lote' + ((this.status !== null && this.status !== undefined) ? ('/listar-por-status/' + this.status) : ''),
      fields: [
        {
          name: 'cd_lote',
          title: 'Código',
          sortField: 'cd_lote'
        },
        {
          name: 'cd_ponto_apoio',
          title: 'Ponto Apoio',
          sortField: 'cd_ponto_apoio'
        },
        {
          name: '__slot:status_desc',
          title: 'Status',
          sortField: 'status_desc'
        },
        {
          name: 'dt_distribuicao',
          title: 'Data',
          sortField: 'dt_distribuicao',
          callback: 'formataData'
        },
        '__slot:actions'
      ],
      sortOrder: [
        { field: 'cd_lote', direction: 'asc' }
      ],
      moreParams: {},
      css: {
        table: {
          tableClass: 'table table-striped table-bordered table-hovered',
          loadingClass: 'loading',
          ascendingIcon: 'glyphicon glyphicon-chevron-up',
          descendingIcon: 'glyphicon glyphicon-chevron-down',
          handleIcon: 'glyphicon glyphicon-menu-hamburger'
        },
        pagination: {
          infoClass: 'pull-left',
          wrapperClass: 'vuetable-pagination pull-right',
          activeClass: 'btn-primary',
          disabledClass: 'disabled',
          pageClass: 'btn btn-border',
          linkClass: 'btn btn-border',
          icons: {
            first: '',
            prev: '',
            next: '',
            last: ''
          }
        }
      }
    }
  },
  mounted () {
    this.$parent.$parent.$data.description = this.titulo

    this.$events.$on('filter-set', eventData => this.onFilterSet(eventData))
  },
  computed: {
    httpOptions () {
      return { headers: { 'Authorization': 'Bearer ' + ActionsLogin.getToken() } }
    }
  },
  watch: {
    status: function (val) {
      if (this.status !== null && this.status !== undefined) {
        this.$parent.$parent.$data.description = this.titulo
        this.urlApi = process.env.URL_API_BASE + '/distribuicao-lote/listar-por-status/' + this.status
      } else {
        this.$parent.$parent.$data.description = 'Listar'
        this.urlApi = process.env.URL_API_BASE + '/distribuicao-lote'
      }
    }
  },
  methods: {
    onPaginationData (paginationData) {
      this.$refs.pagination.setPaginationData(paginationData)
    },
    onChangePage (page) {
      this.$refs.vuetable.changePage(page)
    },
    onLoading () {
      this.$parent.$parent.$data.showModalLoader = true
    },
    onLoaded () {
      this.$parent.$parent.$data.showModalLoader = false
    },
    onFilterSet (filterText) {
      this.moreParams.filter = filterText

      Vue.nextTick(() => {
        if (this.$refs.vuetable !== undefined) {
          this.$refs.vuetable.refresh()
        }
      })
    },
    doFilter () {
      this.$events.fire('filter-set', this.filterText)
    },
    novo () {
      this.$router.push({ path: '/distribuicao-equipamentos/novo', query: { ret_url: this.$router.currentRoute.path } })
    },
    editar (rowData) {
      this.$router.push({ path: '/distribuicao-equipamentos/' + rowData.cd_lote + '/e', query: { ret_url: this.$router.currentRoute.path } })
    },
    view (rowData) {
      this.$router.push({ path: '/distribuicao-equipamentos/' + rowData.cd_lote, query: { ret_url: this.$router.currentRoute.path } })
    },
    excluir (rowData) {
    },
    async gerarExcel () {
      this.$refs.vuetable.refresh()
      let res = await DistribuicaoLoteActions.listarPorStatus(this.status)
      return res
    },
    formataData (val) {
      let date = moment.utc(val)
      if (date.isValid()) {
        return date.format('DD/MM/YYYY')
      }
      return ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/distribuicao-equipamentos/Listar.vue